"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpoints = exports.DEFAULT_WIDTH_FOR_TESTS = void 0;
var breakpoints = {
  medium: '600px',
  large: '960px',
  'extra-large': '1280px',
  huge: '1600px'
};
exports.breakpoints = breakpoints;
var DEFAULT_WIDTH_FOR_TESTS = 200;
exports.DEFAULT_WIDTH_FOR_TESTS = DEFAULT_WIDTH_FOR_TESTS;